import type { AnalystValueFormat } from "@digital-twins/shared-types";

/**
 * A figure as the Analyst prints it, by its typed format (stamped by the
 * producer, never read from its unit label): a share with one decimal and
 * "%", a whole count, any other figure with up to two decimals.
 */
export function formatAnalystValue(value: number, valueFormat: AnalystValueFormat): string {
  const isPercent = valueFormat === "percent";
  const maximumFractionDigits = valueFormat === "count" ? 0 : isPercent ? 1 : 2;
  const formatted = new Intl.NumberFormat(undefined, {
    maximumFractionDigits,
  }).format(value);

  return isPercent ? `${formatted}%` : formatted;
}
